import { Guid } from "@/Common/Models/Guid";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum DocumentViewActionComponentId {
    OntarioMdHealthReportManager_HrmInfoButton = 0
}

interface IDocumentViewActionRegistryProps {
    documentId: Guid;
    source?: string;
}

class DocumentViewActionRegistry extends BaseComponentRegistry<DocumentViewActionComponentId, IDocumentViewActionRegistryProps> {}

const DocumentViewActionRegistryView = createRegistryListView(() => DocumentViewActionRegistry.getInstance());

export {
    DocumentViewActionComponentId,
    DocumentViewActionRegistry,
    DocumentViewActionRegistryView,
    IDocumentViewActionRegistryProps
};
